var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _circle4, _path16, _path17, _circle5, _circle6, _path18, _path19, _circle7, _path20, _circle8, _circle9, _path21, _circle0, _path22, _circle1, _path23, _circle10, _path24, _path25, _circle11, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiggyBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242 248",
    fillRule: "evenodd",
    clipRule: "evenodd",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.5 141.098c0 58.261-47.677 105.5-106.5 105.5s-106.5-47.239-106.5-105.5c0-58.262 47.677-105.5 106.5-105.5s106.5 47.238 106.5 105.5z",
    fill: "#fce8f3",
    stroke: "#18191b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    fill: "#18191b",
    transform: "matrix(-1 0 0 1 206.5 188)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    fill: "#18191b",
    transform: "matrix(-1 0 0 1 206.5 190)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 0.5,
    fill: "#18191b",
    transform: "matrix(-1 0 0 1 206.5 186)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8b4d9",
    stroke: "#18191b",
    d: "M33.5 176h174v34h-174z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8b4d9",
    stroke: "#18191b",
    d: "M9.5 197h222v32H9.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 112h18",
    fill: "none",
    stroke: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.534 92.688c-2.279-.355-2.491-2.879-1.48-4.49 1.083-1.359 3.865-.12 3.418 1.815-.296 1.277-.088 2.962-1.938 2.675zm-23.755 31.109c-2.212.651-3.481-1.543-3.252-3.431.401-1.691 3.445-1.756 3.865.185.278 1.282 1.183 2.718-.613 3.246z",
    fill: "#f17eb8",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.012 80.851c1.06 1.445 2.607 2.536 3.961 3.693.385-.814-.631-3.96-.925-4.595-.709-1.531-.998-3.32-1.626-4.907-1.525-3.854-3.213-7.697-5.113-11.398-1.376-2.683-2.842-5.161-4.463-7.694-.616-.962-1.335-2.444-2.582-2.725-1.796-.405-1.772 2.535-1.694 3.771.09 1.439.922 2.717 1.516 3.998l.04.086c1.474 3.183 2.927 6.319 4.713 9.345 2.037 3.452 3.8 7.192 6.173 10.426z",
    fill: "#f17eb8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.181 84.724c-1.401-1.225-3.054-2.354-4.169-3.873-2.373-3.234-4.136-6.974-6.173-10.426-1.802-3.054-3.265-6.218-4.753-9.431-.594-1.281-1.426-2.559-1.516-3.998-.078-1.236-.102-4.176 1.694-3.771 1.247.281 1.966 1.763 2.582 2.725 1.621 2.533 3.087 5.011 4.463 7.694 1.9 3.701 3.588 7.544 5.113 11.398.628 1.587.917 3.376 1.626 4.907.306.66 1.39 4.031.873 4.68",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.931 116.294c1.574.855 3.439 1.183 5.156 1.653.002-.901-2.257-3.314-2.795-3.763-1.293-1.083-2.317-2.578-3.561-3.747-3.022-2.836-6.187-5.593-9.483-8.132-2.388-1.84-4.771-3.458-7.316-5.058-.967-.608-2.25-1.642-3.497-1.365-1.798.399-.523 3.048.074 4.133.695 1.264 1.992 2.065 3.076 2.971l.072.061c2.69 2.251 5.341 4.468 8.246 6.445 3.314 2.255 6.503 4.887 10.028 6.802z",
    fill: "#f17eb8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.352 118.021c-1.789-.512-3.765-.828-5.421-1.727-3.525-1.915-6.714-4.547-10.028-6.802-2.931-1.994-5.603-4.234-8.318-6.506-1.084-.906-2.381-1.707-3.076-2.971-.597-1.085-1.872-3.734-.074-4.133 1.247-.277 2.53.757 3.497 1.365 2.545 1.6 4.928 3.218 7.316 5.058 3.296 2.539 6.461 5.296 9.483 8.132 1.244 1.169 2.268 2.664 3.561 3.747.559.467 2.976 3.054 2.785 3.862",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M178.511 87.336c-4.148.817-.704 4.687 1.111 3.072 2.198-1.956.542-2.513-1.111-3.072z",
    fill: "#f17eb8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M178.647 87.31c-4.358.76-.86 4.73.975 3.098 2.488-2.215.038-2.636-1.757-3.297",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M200.286 123.195c-4.068-1.153-2.754 3.858-.404 3.242 2.847-.747 1.624-1.994.404-3.242z",
    fill: "#f17eb8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.419 123.234c-4.229-1.3-2.912 3.826-.537 3.203 3.223-.845 1.23-2.332-.07-3.736",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183.129 72.222c-1.451 3.649-2.398 7.441-3.707 11.14-.047.658.158 1.01 1.052.977.754-.028 1.395-.085 1.915-.685.482-.557.729-1.383 1.138-1.995 1.244-1.858 2.739-4.03 3.401-6.189.54-1.763 1.753-3.389 2.595-5.016 1.1-2.126 1.9-4.721 2.575-7.018.86-2.928 2.106-5.817 2.239-8.893.035-.814-.282-.749-.877-.461-.41.2-.804-.048-1.055.284-.969 1.282-1.765 2.47-2.542 3.908-2.424 4.493-4.846 9.203-6.734 13.948z",
    fill: "#f17eb8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.381 83.478c1.33-3.736 2.282-7.569 3.748-11.256 1.888-4.745 4.31-9.455 6.734-13.948.777-1.438 1.573-2.626 2.542-3.908.251-.332.645-.084 1.055-.284.595-.288.912-.353.877.461-.133 3.076-1.379 5.965-2.239 8.893-.675 2.297-1.475 4.892-2.575 7.018-.842 1.627-2.055 3.253-2.595 5.016-.662 2.159-2.157 4.331-3.401 6.189-.409.612-.656 1.438-1.138 1.995-.52.6-1.161.657-1.915.685-1.097.041-1.157-.498-.986-1.472",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M211.257 111.82c-2.949 2.593-5.513 5.543-8.358 8.247-.34.565-.317.972.495 1.348.685.317 1.282.557 2.017.258.683-.278 1.278-.903 1.919-1.262 1.952-1.092 4.27-2.349 5.839-3.973 1.281-1.327 3.099-2.225 4.588-3.293 1.945-1.396 3.835-3.346 5.478-5.087 2.095-2.22 4.515-4.229 6.029-6.91.401-.709.088-.796-.572-.808-.456-.009-.695-.408-1.07-.226-1.445.703-2.693 1.4-4.037 2.33-4.199 2.905-8.494 6.004-12.328 9.376z",
    fill: "#f17eb8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M202.811 120.151c2.88-2.726 5.466-5.711 8.446-8.331 3.834-3.372 8.129-6.471 12.328-9.376 1.344-.93 2.592-1.627 4.037-2.33.375-.182.614.217 1.07.226.66.012.973.099.572.808-1.514 2.681-3.934 4.69-6.029 6.91-1.643 1.741-3.533 3.691-5.478 5.087-1.489 1.068-3.307 1.966-4.588 3.293-1.569 1.624-3.887 2.881-5.839 3.973-.641.359-1.236.984-1.919 1.262-.735.299-1.332.059-2.017-.258-.996-.462-.805-.969-.212-1.759",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 90.098,
    r: 5.5,
    fill: "#faca15",
    stroke: "#18191b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.819 88.855c-.17-.411-.539-.451-.932-.594-.28-.102-.686-.051-.95.071-.41.188-.664.28-.964.655-.258.322-.538.765-.36 1.187.212.504.515.913 1.051 1.095.469.16.975.119 1.462.119.166 0 .413-.033.495-.198",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M119.433 86.322c-.056.92-.04 1.841-.04 2.762 0 .292-.034.609.02.899.068.367.037.821 0 1.185-.06.59-.059 1.17-.059 1.764m6.473-9.767c.493-.508.935-1.245 1.556-1.556m-9.076-1.296v-2.075m-7.261 5.446c-.561-.408-1.216-.997-1.816-1.296m18.817 8.459c.473-.008 1.841.078 2.302-.23m-20.608.805h-2.418",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 63 37.5)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 236 181.5)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.318 241.818a.318.318 0 010-.636h1.364v-1.364a.318.318 0 01.636 0v1.364h1.364a.318.318 0 010 .636h-1.364v1.364a.318.318 0 11-.636 0v-1.364h-1.364z",
    fill: "#18191b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201 241a1.5 1.5 0 10-.001-3.001A1.5 1.5 0 00201 241z",
    fill: "none",
    stroke: "#18191b"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 4 173.5)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.794 31.294a.794.794 0 010-1.588h3.412v-3.412a.794.794 0 011.588 0v3.412h3.412a.794.794 0 010 1.588h-3.412v3.412a.794.794 0 01-1.588 0v-3.412h-3.412zm201.56 25a.5.5 0 110-1h2.147v-2.147a.5.5 0 111 0v2.147h2.147a.5.5 0 010 1h-2.147v2.147a.5.5 0 01-1 0v-2.147h-2.147z",
    fill: "#18191b"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 205 21.5)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 140.5,
    r: 14.5,
    fill: "#e5e7eb",
    stroke: "#18191b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.783 133.12a.254.254 0 01.294-.109c.104.03.173.108.173.234 0 .959.397 1.717.933 2.374.394.482.893.943 1.385 1.398.156.144.312.288.463.431 1.279 1.214 2.469 2.598 2.469 5.052 0 3.032-2.468 5.5-5.5 5.5s-5.5-2.468-5.5-5.5c0-1.677.797-3.064 1.568-3.873a.25.25 0 01.432.171v2.672c0 1.363 1.085 2.511 2.467 2.529m.816-10.879l-.413-.282.413.282zm0 0c-.941 1.375-1.267 2.358-1.291 3.088-.024.708.236 1.243.632 1.739.203.253.437.491.69.738l.141.137c.205.2.421.409.615.623.485.531.93 1.18.93 2.055a2.5 2.5 0 01-2.533 2.499m0 0l.006-.5-.006.5z",
    fill: "#6c727f",
    stroke: "#000"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 140.5,
    r: 14.5,
    fill: "#e5e7eb",
    stroke: "#18191b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M230.183 137.115c-.017-.059-.073-.114-.183-.116a.234.234 0 00-.124.033.162.162 0 00-.065.092l.372-.009zm0 0l.002.009m-.002-.009l.002.009m0 0c.533 1.697 1.355 2.805 2.032 3.72l.113.152c.703.952 1.17 1.657 1.17 2.678 0 1.816-1.543 3.325-3.5 3.325-1.958 0-3.5-1.506-3.5-3.325 0-1.015.468-1.723 1.172-2.68m2.513-3.87l-2.513 3.87m0 0l.113-.153m-.113.153l.113-.153m0 0c.677-.918 1.497-2.029 2.026-3.717l-2.026 3.717zm-3.521-5.216c.229-.322.508-.714.736-1.247.228.536.508.928.738 1.25l.049.069c.308.434.463.691.463 1.061 0 .684-.555 1.241-1.25 1.241s-1.25-.557-1.25-1.241c0-.367.155-.626.463-1.061l.051-.072zm-3.25 6c.229-.322.508-.714.736-1.247.228.536.508.928.738 1.25l.049.069c.308.434.463.691.463 1.061 0 .684-.555 1.241-1.25 1.241s-1.25-.557-1.25-1.241c0-.367.155-.626.463-1.061l.051-.072z",
    fill: "#6c727f",
    stroke: "#18191b"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 226.5,
    r: 14.5,
    fill: "#e5e7eb",
    stroke: "#18191b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.822 230.328l-2.496-2.828h.957a.71.71 0 00.649-.408.688.688 0 00-.102-.751l-2.442-2.841h.903a.71.71 0 00.652-.425.696.696 0 00-.133-.753l-3.446-3.671a.515.515 0 00-.728 0l-3.447 3.671a.697.697 0 00-.132.753.708.708 0 00.652.425h.903l-2.442 2.841a.688.688 0 00-.102.751.708.708 0 00.649.408h.957l-2.496 2.828a.691.691 0 00-.112.758.725.725 0 00.657.414H60v.764l-.947 1.513a.5.5 0 00.448.724h2.998a.5.5 0 00.447-.724L62 232.264v-.764h4.277a.724.724 0 00.656-.414.69.69 0 00-.111-.758z",
    fill: "#6c727f",
    stroke: "#18191b"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 226.5,
    r: 14.5,
    fill: "#e5e7eb",
    stroke: "#18191b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.897 226.499H171.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5h4.444c.497 0 .962.34 1.044.831a1.002 1.002 0 01-1.938.484c-.066-.196-.269-.315-.475-.315h-1.025c-.306 0-.553.275-.497.575a3.008 3.008 0 002.944 2.425 3.004 3.004 0 002.975-3.394c-.191-1.512-1.553-2.606-3.075-2.606zm-4.397-1H182a3.006 3.006 0 002.931-3.647 2.988 2.988 0 00-2.284-2.284 3.007 3.007 0 00-3.591 2.359c-.059.3.191.572.494.572h1.025c.209 0 .409-.119.475-.316.134-.397.509-.684.95-.684.606 0 1.091.544.988 1.169-.082.49-.544.831-1.044.831H171.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5zm12 1h-4.884a3.947 3.947 0 011.243 2h3.641a1.5 1.5 0 010 3c-.559 0-1.041-.31-1.3-.763a.518.518 0 00-.453-.237h-1.056c-.341 0-.594.337-.479.659.557 1.581 2.204 2.65 4.044 2.26a3.49 3.49 0 002.647-2.585 3.507 3.507 0 00-3.403-4.334z",
    fill: "#8f959f",
    stroke: "#18191b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M91.547 163.921v13.478a5 5 0 005 5h7.924a5 5 0 005-5v-7.387h25.849v7.363a5 5 0 005 5h7.83a5 5 0 005-5v-13.33l6.299-6.298h7.2c2.76 0 5-2.239 5-5v-20.16c0-2.761-2.24-5-5-5h-3.147l-7.77-10.768 3.582-14.523s-6.018-.934-8.798 0c-3.3 1.107-8.552 5.621-10.991 6.646-1.131.475-2.42-.479-3.646-.498-5.391-.083-21.131-1.107-28.787.495-6.44 1.348-12.56 4.948-17.15 9.117-4.571 4.153-10.302 15.4-10.302 15.4h-8.881a4.923 4.923 0 01-4.926-4.926v-.001a4.923 4.923 0 014.926-4.926h1.062v-5.93h-.982c-5.772 0-10.452 4.68-10.452 10.452v.004c0 6.087 4.935 11.022 11.022 11.022h6.627a2 2 0 011.792 1.112l11.719 23.658z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.043,
    cy: 136.043,
    r: 4.04,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.006 111.615h18.619",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.475 66.231a1 1 0 001 .977h72.381a1 1 0 001-1V62.35c0-1.542-.71-2.998-1.927-3.945l-12.87-10.023a4.997 4.997 0 01-1.928-3.898c-.027-2.548-.04-6.584.093-9.523.138-3.053 10.706-12.199 17.363-16.683 6.145-4.14 20.437-9.856 23.621-11.108a.998.998 0 00.636-.93V2.615a1 1 0 00-1-1H89.808a1 1 0 00-1 1v1.897a.997.997 0 01-1 1h-37.08a1.001 1.001 0 00-.751 1.661c3.006 3.432 10.177 11.203 15.531 13.576 6.187 2.742 21.407 5.23 28.842 6.33a4.989 4.989 0 014.215 4.93c.01 3.825.01 9.265.01 12.383a5.004 5.004 0 01-1.935 3.95l-12.33 9.57a5.002 5.002 0 00-1.934 4.066l.1 4.252z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  })));
}
export default SvgPiggyBank;